<script setup lang="ts">
import { defineAsyncComponent, markRaw } from 'vue'

/* Stores */
import { useBannersStore } from '~/store/banners/banners'

/* Components */
import MainSwipperBanner from '@/components/Main/MainSwipperBanner.vue'
import BannerSkeleton from '@/components/Main/MainSkeletonBanner.vue'

const MainFailed = defineAsyncComponent(
  () => import('@/components/Main/MainFailed.vue'),
)

const bannersStore = useBannersStore()
const bannerError = computed(() => bannersStore.error)
const bannersLoading = computed(() => bannersStore.isLoading)

const determinantState = computed(() => {
  if (bannersLoading.value) return markRaw(BannerSkeleton)

  if (bannerError?.value?.message) return markRaw(MainFailed)

  return markRaw(MainSwipperBanner)
})

onMounted(async () => {
  await bannersStore.fetchBanners()
})
</script>

<template>
  <component :is="determinantState" @update-data="bannersStore.fetchBanners" />
</template>
